import "../../../datagrid.scss";
import { useContext, useEffect, useState, useRef, useMemo } from 'react';
import { Modal, Box } from "@mui/material";
import FormDetalle from './formDetalle/formDetalle';
import DetalleFiltersModal from './gridDetalle/detalleFiltersModal';
import { OfertasDetFormState } from '../../../../context/ofertasdet/OfertasDetFormState';
import { OfertasDetContext } from '../../../../context/ofertasdet/OfertasDetContext';
import { ArticulosState } from '../../../../context/articulos/ArticulosState';
import { formatRows } from "./configGrid//rows";
import { indice } from "../../../../components/DataGrid/indice";
import { getActionColumn } from "../../../../components/DataGrid/actionColumns";
import useDocumentTitle from "../../../../components/Title";
import CustomDataGrid from "../../../../components/DataGrid/CustomDataGrid"
import ConfirmDialog from "../../../../components/dialogs/DeleteDialog";
import ErrorDialog from "../../../../components/dialogs/ErrorDeleteDialog";
import { fetchEntityData, deleteItem } from './configGrid/apiCalls';
import FiltersGrid from './filtersGrid/filtersGrid';
import { Paginator } from '../../../../components/paginator/Paginator';
import { getHeaders } from "./configGrid/headers";
import CircularProgress from "@mui/material/CircularProgress";
import { LuRows } from "react-icons/lu";

export const DatatableDetalle = ({ 
  aofid, 
  tipoprecio,
  tipooferta, 
  arrayDetalle, 
  addItem, 
  getItem, 
  updateItem, 
  removeItem, 
  clearArray, 
  isCabComplete,
  setIsDetalleFilled }) => {
  const contexto = useContext(OfertasDetContext);
  const { deleteOfertaDetData, getOfertaDetPanelData, getOfertaDetByIdData } = contexto;
  const [isModalDetalleOpen, setIsModalDetalleOpen] = useState(false);
  const [isModalArrayDetalleOpen, setIsModalArrayDetalleOpen] = useState(false);
  const [ultimoIdOferta, setUltimoIdOferta] = useState();

  // Estado para Datos y Paginacion
  const [listaItems, setListaItems] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [totalDataItems, setTotalDataItems] = useState(0);
  // Estado para Loading
  const [isLoading, setIsLoading] = useState(false);
  // Estados para la paginación
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [numPagina, setNumPagina] = useState(1);
  const [filas, setFilas] = useState(isMobile ? 20 : 100);
  // Estado del buscador
  const [searchArtId, setSearchArtId] = useState();
  const [searchArtDesc, setSearchArtDesc] = useState();
  // Ref de input
  const searchInputRef = useRef(null);
  const isFetchingRef = useRef(false);
  // Estado para el modal de confirmación
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  // Estado para manejar el error
  const [errorMessage, setErrorMessage] = useState("");
  const [isErrorDialogOpen, setIsErrorDialogOpen] = useState(false);

  const nameData = "Articulo";
  const getData = getOfertaDetPanelData;
  const deleteData = deleteOfertaDetData;

  useEffect(() => {
    fetchData();
  }, [aofid, searchArtId, numPagina, filas, JSON.stringify(arrayDetalle)]);
  
  useEffect(() => {
    // Si cambia tipoPrecio o tipoOferta, limpiar el array de detalles
    if (arrayDetalle.length > 0) {
      clearArray(); // Llama a la función que limpia `arrayDetalle`
    }
  }, [tipoprecio, tipooferta]);

  useEffect(() => {
    setIsDetalleFilled(totalDataItems > 0);
  }, [totalDataItems]);


  const fetchData = async () => {
    if (isFetchingRef.current) return; // Evita múltiples llamadas simultáneas
    isFetchingRef.current = true;
    setIsLoading(true);
    try {
      const { totalPage } = await fetchEntityData(
        getData,
        searchArtId,
        numPagina,
        filas,
        aofid,
        setListaItems,
        setTotalItems,
        arrayDetalle
      );
    
      if (numPagina > totalPage) {
        setNumPagina(totalPage);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
      isFetchingRef.current = false;
    }
  };

  const handleClickEdit = async (id) => {
    try {
      setSelectedItem(id)

      // Abre el modal después de cargar los datos en selectedRow
      handleOpenDetalleModal();
    } catch (error) {
      console.error("Error al obtener detalles:", error);
    }
  };

  const handleDelete = async () => {
    try {
      await deleteItem(deleteData, selectedItem, arrayDetalle, removeItem, getOfertaDetByIdData);
      await fetchData(); // Refresca los datos
      closeModal(); // Cierra el modal de confirmación
    } catch (error) {
      console.error(error);
      setErrorMessage("No se pudo eliminar el elemento. Inténtalo nuevamente.");
      setIsErrorDialogOpen(true);
    }
  };

  const closeErrorDialog = () => {
    setErrorMessage(""); // Limpia el mensaje de error
    setIsErrorDialogOpen(false); // Cierra el diálogo de error
  };

  const openModal = (id) => {
    setSelectedItem(id);
    setIsModalOpen(true);
  };

  const closeModal = async () => {
    await fetchData()
    setSelectedItem(null);
    setIsModalOpen(false);
  };

  const handleOpenDetalleModal = () => {
    setIsModalDetalleOpen(true);
  };

  const handleCloseDetalleModal = async () => {
    await fetchData()
    setIsModalDetalleOpen(false);  // Función para cerrar el modal
    setSelectedItem(null);

  };

  const handleArrayDetalleOpenModal = () => {
    setIsModalArrayDetalleOpen(true);  // Función para abrir el modal
  };

  const handleArrayDetalleCloseModal = async () => {
    await fetchData()
    setIsModalArrayDetalleOpen(false);
  };

  const headers = getHeaders(tipooferta);

  // Dentro de la función Datatable...
  const datosColum = useMemo(() => {
    const commonCols = indice(numPagina, filas).concat(headers.filter((column) => !column.hidden)).concat(getActionColumn(handleClickEdit, openModal));
    return commonCols
  }, [numPagina, filas, tipooferta]);

  const rows = useMemo(() => {
    return formatRows(listaItems, tipooferta);
  }, [listaItems, tipooferta]);

  return (
    <>
      <div className="datatable">
        <div className="datatableTitle">
          Lista de los Articulos En Oferta
          {aofid &&
            <>
              <FiltersGrid
                setSearchIDFilter={setSearchArtId}
                setSearchDescFilter={setSearchArtDesc}
              />
            </>
          }
          <button
            type="button"
            className={`link ${!isCabComplete ? "disabled" : "enabled"}`}
            onClick={handleOpenDetalleModal}
            disabled={!isCabComplete} // Deshabilitar si no está completo

          >
            Agregar
          </button>
          <button
            type="button"
            className={`link ${!isCabComplete ? "disabled" : "enabled"}`}
            onClick={handleArrayDetalleOpenModal}
            disabled={!isCabComplete} // Deshabilitar si no está completo

          >
            Agregar con filtros
          </button>

        </div>

        <> 
            <CustomDataGrid
              rows={rows}  // Filtrar según la página actual
              columns={datosColum}
              pageSize={filas}
              rowCount={totalItems} 
              onPageChange={(newPage) => setNumPagina(newPage)}  // Actualizar página
              onPageSizeChange={(newPageSize) => {
                setFilas(newPageSize);
                setNumPagina(1);  // Resetear la página cuando se cambia el tamaño
              }}
              isLoading={isLoading}
              enablePagination={false}
            /> 

          <div className="paginatorWrapper">
            <Paginator
              numPagina={numPagina}
              setNumPagina={setNumPagina}
              totalPages={Math.ceil(totalItems / filas)}  // Total de páginas
              filas={filas}
              setFilas={setFilas}
              totalDataItems={totalItems}
            />
          </div>
          <ConfirmDialog
            open={isModalOpen}
            onClose={closeModal}
            onConfirm={handleDelete}
            nameData={nameData}
          />
          <ErrorDialog
            open={isErrorDialogOpen}
            onClose={closeErrorDialog}
            errormessages={errorMessage}
          />
        </>

      </div>

      <OfertasDetFormState>
        <Modal
          open={isModalArrayDetalleOpen}
          onClose={handleArrayDetalleCloseModal}
          aria-labelledby="modal-form-detalle"
          aria-describedby="modal-form-detalle-descripcion"
          className="modalOferta"
        >
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              maxWidth: '80%', // Se ajusta para ser responsive
              maxHeight: '80%', // Limitar la altura
              width: '100%', // El ancho ocupará el 100% hasta el máximo
              height: 'auto', // Deja que la altura dependa del contenido
              bgcolor: 'background.paper',
              borderRadius: '8px',
              boxShadow: 24,
              p: 4,
              overflowY: 'auto', // Habilitar scroll vertical
            }}
          >

            <ArticulosState>
              <DetalleFiltersModal
                tipooferta={tipooferta}
                tipoprecio={tipoprecio}
                addItem={addItem}
                closeModal={handleArrayDetalleCloseModal}
              /></ArticulosState>


          </Box>
        </Modal>
      </OfertasDetFormState>

      <OfertasDetFormState>
        <Modal
          open={isModalDetalleOpen}
          onClose={handleCloseDetalleModal}
          aria-labelledby="modal-form-detalle"
          aria-describedby="modal-form-detalle-descripcion"
          className="modalOferta"
        >
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              maxWidth: '80%', // Se ajusta para ser responsive
              maxHeight: '80%', // Limitar la altura
              width: '100%', // El ancho ocupará el 100% hasta el máximo
              height: 'auto', // Deja que la altura dependa del contenido
              bgcolor: 'background.paper',
              borderRadius: '8px',
              boxShadow: 24,
              p: 4,
              overflowY: 'auto', // Habilitar scroll vertical

            }}
          >
            <FormDetalle
              iddet={selectedItem}
              aofid={aofid}
              tipooferta={tipooferta}
              tipoprecio={tipoprecio}
              arrayDetalle={arrayDetalle}
              addItem={addItem}
              updateItem={updateItem}
              getItem={getItem}
              removeItem={removeItem}
              ultimoID={ultimoIdOferta}
              closeModal={handleCloseDetalleModal}
              totalItems={totalItems}  // Cambié esto
            />
          </Box>
        </Modal>
      </OfertasDetFormState>
    </>
  );
};

export default DatatableDetalle;